module.exports = {"TXTWCL_You_have_promotions_available__ELL":{"id":"TXTWCL_You_have_promotions_available__ELL","defaultMessage":"その他の通貨のプロモーションがあります。"}}